import {
  createDefaultMatterFileRepositoryStructureFolderV1,
  deleteDefaultMatterFileRepositoryStructureFolderV1,
  retrieveDefaultMatterFileRepositoryStructureFolderV1,
} from "@/lib/data/requests/matters/matter-default-file-repository-structure-folder";
import { queryKeys } from "@/lib/data/static";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";

export const retrieveDefaultMatterFileRepositoryStructureFolderQueryOptions = (
  defaultFileReposityStructureId: string,
) => {
  return {
    queryKey: [
      queryKeys.matterDefaultFileRepositoryStructureFolders,
      defaultFileReposityStructureId,
    ],
    queryFn: async () =>
      retrieveDefaultMatterFileRepositoryStructureFolderV1(
        defaultFileReposityStructureId,
      ),
  };
};

export const useCreateDefaultMatterFileRepositoryStructureFolder = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (
      data: Parameters<
        typeof createDefaultMatterFileRepositoryStructureFolderV1
      >[0],
    ) => createDefaultMatterFileRepositoryStructureFolderV1(data),
    onError: () => {
      toast.error(
        "Error creating default matter file repository structure folder",
      );
    },
    onSettled: async () => {
      await queryClient.invalidateQueries({
        queryKey: [queryKeys.matterDefaultFileRepositoryStructureFolders],
      });
    },
    onSuccess: () => {
      toast.success(
        "Default matter file repository structure folder created successfully",
      );
    },
  });
};

export const useDeleteDefaultMatterFileRepositoryStructureFolder = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (
      data: Parameters<
        typeof deleteDefaultMatterFileRepositoryStructureFolderV1
      >[0],
    ) => deleteDefaultMatterFileRepositoryStructureFolderV1(data),
    onError: () => {
      toast.error(
        "Error deleting default matter file repository structure folder",
      );
    },
    onSettled: async () => {
      await queryClient.invalidateQueries({
        queryKey: [queryKeys.matterDefaultFileRepositoryStructureFolders],
      });
    },
    onSuccess: () => {
      toast.success(
        "Default matter file repository structure folder deleted successfully",
      );
    },
  });
};
